module.exports = __webpack_public_path__ + "img/education2.2f99893c.png";